import { render, staticRenderFns } from "./AgentsList.vue?vue&type=template&id=2e7145a2&"
import script from "./AgentsList.vue?vue&type=script&lang=js&"
export * from "./AgentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports